export { default } from './ActivityAvatar';
